/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reverse_Rtl_Start_EndInputs */



/**
* | output |
* | --- |
* | "Reverse RTL Start and End" |
*
* @param {Reverse_Rtl_Start_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reverse_rtl_start_end = /** @type {((inputs?: Reverse_Rtl_Start_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reverse_Rtl_Start_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inverser le début et la fin RTL")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umgekehrter RTL-Start und -Ende")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio e fine RTL inversi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратное начало и конец RTL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio y fin RTL inverso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("反向 RTL 起始和结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("逆RTLの開始と終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवर्स आरटीएल प्रारंभ और समाप्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Início e fim do RTL reverso")
	return /** @type {LocalizedString} */ ("Reverse RTL Start and End")
});